import React from 'react';
import { Link } from 'react-router-dom';

const namapagesIntro = `Namapages is a comprehensive digital repository dedicated to preserving and sharing the sacred musical heritage of Dakshina Bharatha Sampradaya bhajans. This spiritual application serves as a treasure trove of devotional songs (Bhagavan Nama) that have been lovingly composed and sung by revered bhaktas, sadhus, and spiritual composers across generations.`;

const Privacy = () => (
  <div style={{ maxWidth: 720, margin: '0 auto', padding: '0.5rem' }}>
    {/* Header card */}
    <div className="np-panel" style={{
      background: 'linear-gradient(135deg, #F0C040 0%, #FFE082 50%, #E8A800 100%)',
      border: '2px solid var(--gold-deep)',
      boxShadow: '0 4px 18px rgba(184,134,11,0.25)',
      marginBottom: '1.5rem', textAlign: 'center', padding: '1.75rem 1.5rem'
    }}>
      <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🔒</div>
      <h1 style={{ fontFamily: 'var(--font-heading)', color: 'var(--brown-deep)', letterSpacing: '2px', margin: 0, fontSize: '1.5rem' }}>
        Privacy & Disclaimer
      </h1>
      <p style={{ fontFamily: 'var(--font-body)', fontStyle: 'italic', color: 'var(--brown-mid)', opacity: 0.85, margin: '0.5rem 0 0', fontSize: '0.85rem' }}>
        Transparency about how we handle your information
      </p>
    </div>

    {/* About section */}
    <div className="np-panel" style={{ marginBottom: '1rem' }}>
      <h2 style={{ fontFamily: 'var(--font-heading)', color: 'var(--maroon-mid)', fontSize: '0.95rem', letterSpacing: '1.5px', textTransform: 'uppercase', margin: '0 0 0.75rem' }}>
        🪷 About Namapages
      </h2>
      <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.8, margin: 0 }}>
        {namapagesIntro}
      </p>
    </div>

    {/* Disclaimer */}
    <div className="np-panel" style={{ marginBottom: '1rem' }}>
      <h2 style={{ fontFamily: 'var(--font-heading)', color: 'var(--maroon-mid)', fontSize: '0.95rem', letterSpacing: '1.5px', textTransform: 'uppercase', margin: '0 0 0.75rem' }}>
        📜 Disclaimer
      </h2>
      <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '0.85rem' }}>
        Namapages is an information-only website and app, providing a curated collection of devotional songs and related
        content. All song information is based on publicly available artifacts, sources, and references. The content is
        intended for spiritual and educational purposes only.
      </p>
      <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '0.85rem' }}>
        Under no circumstances does the owner, developer, or maintainer of Namapages accept responsibility or liability
        for the accuracy, completeness, or quality of the content provided. All information and songs are presented
        as-is, and users are advised to use their own discretion when interpreting or utilizing the content.
      </p>
      <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-secondary)', lineHeight: 1.8, margin: 0 }}>
        If you believe any content infringes on copyright or should be removed, please contact us via the{' '}
        <Link to="/support" style={{ color: 'var(--gold-deep)', fontWeight: 600, textDecoration: 'none' }}>Support page</Link>.
      </p>
    </div>

    {/* Privacy */}
    <div className="np-panel" style={{ marginBottom: '1rem' }}>
      <h2 style={{ fontFamily: 'var(--font-heading)', color: 'var(--maroon-mid)', fontSize: '0.95rem', letterSpacing: '1.5px', textTransform: 'uppercase', margin: '0 0 0.75rem' }}>
        🛡️ Privacy
      </h2>
      <div style={{
        display: 'flex', alignItems: 'flex-start', gap: '0.75rem',
        background: 'linear-gradient(135deg, var(--gold-glow), var(--parchment))',
        border: '1px solid var(--border-gold)', borderRadius: 'var(--radius-md)',
        padding: '0.85rem 1rem', marginBottom: '0.85rem'
      }}>
        <span style={{ fontSize: '1.4rem', flexShrink: 0 }}>✅</span>
        <p style={{ fontFamily: 'var(--font-body)', color: 'var(--text-primary)', lineHeight: 1.7, margin: 0 }}>
          <strong style={{ color: 'var(--maroon-mid)' }}>No user data is collected, stored, or shared</strong> by Namapages.
          We do not require user registration, nor do we track or profile visitors in any way.
        </p>
      </div>
    </div>

    {/* Acceptance */}
    <div className="np-panel" style={{ marginBottom: '1.5rem', background: 'var(--parchment-dark)', textAlign: 'center', padding: '1rem' }}>
      <p style={{ fontFamily: 'var(--font-body)', fontStyle: 'italic', color: 'var(--text-muted)', fontSize: '0.88rem', margin: 0 }}>
        By using Namapages, you acknowledge and accept this disclaimer and privacy policy.
      </p>
    </div>

    <div style={{ textAlign: 'center' }}>
      <Link to="/" className="np-btn">🏠 Back to Home</Link>
    </div>
  </div>
);

export default Privacy;
